import { render, staticRenderFns } from "./BillingPlansTotalCards.vue?vue&type=template&id=710dc410&"
import script from "./BillingPlansTotalCards.vue?vue&type=script&lang=ts&"
export * from "./BillingPlansTotalCards.vue?vue&type=script&lang=ts&"
import style0 from "./BillingPlansTotalCards.vue?vue&type=style&index=0&id=710dc410&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports